import axios from './request'

let instance = axios

function toParams (obj) {
  let str = '?'
  for (let o in obj) {
    if (obj[o] || obj[o] === 0) {
      str += `${o}=${obj[o]}&`
    }
  }
  return str.slice(0, -1)
}

export default {
  get (url, params, headers) {
    let options = {}
    if (params) {
      options.params = params
      options.url = url + toParams(params)
    }
    if (headers) {
      options.headers = headers
    }
    return instance.get(url, options)
  },
  post (url, params, headers) {
    let options = {}
    if (headers) {
      options.headers = headers
    }
    return instance.post(url, params, options)
  },
  put (url, params, headers) {
    let options = {}
    if (headers) {
      options.headers = headers
    }
    return instance.put(url, params, options)
  },
  delete (url, params, headers) {
    let options = {}
    if (params) {
      options.params = params
    }
    if (headers) {
      options.headers = headers
    }
    return instance.delete(url, options)
  },
  patch (url, params, headers) {
    let options = {}
    if (headers) {
      options.headers = headers
    }
    return instance.patch(url, params, options)
  }
}
